var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65627 0.5L13.9999 10.2681L26.3436 0.5H1.65627ZM0 1.79808V16.5C0 17.6046 0.895431 18.5 2 18.5H26C27.1046 18.5 28 17.6046 28 16.5V1.79808L14.604 12.399C14.2472 12.6803 13.7524 12.6803 13.3957 12.399L0 1.79808Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMall);
export default __webpack_public_path__ + "static/media/ic-mall.275ef45ecfbcc89f097f709f761dbf29.svg";
export { ForwardRef as ReactComponent };